import { render, staticRenderFns } from "./ProgramSlotSpeaker.vue?vue&type=template&id=6b2532ae"
import script from "./ProgramSlotSpeaker.vue?vue&type=script&lang=ts"
export * from "./ProgramSlotSpeaker.vue?vue&type=script&lang=ts"
import style0 from "./ProgramSlotSpeaker.vue?vue&type=style&index=0&id=6b2532ae&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports